const RADIX = 36;

/**
 * A simple utility for creating a random, unique identifier. There are fancier
 * ways to do this with window.crypto and window.performance but this is
 * readable and sufficiently random for most use cases.
 *
 * Do not use this for anything security-related.
 */
export const randomId = () => {
  const datePart = Date.now().toString(RADIX);
  const randomPart = Math.random().toString(RADIX);
  return `${datePart}.${randomPart}`;
};
